import { Box, BoxProps, Text, useColorModeValue, VStack } from "@chakra-ui/react";
import { EmptyNotificationIllustration, EmptyTransactionIllustration, ErrorMojiSVG } from "assets";
import { useMemo } from "react";
import { when } from "utils";

interface EmptyCrateProps extends BoxProps {
  description?: string;
  type: "transaction" | "wallet" | "earn" | "notification" | "p2p" | "greenbox" | "coinSelect";
  midfix?: string;
}

export default function EmptyCrate(props: EmptyCrateProps) {
  const { type = "transaction", midfix, description, children, ...xprops } = props;

  const bg = useColorModeValue("white", "dark.cardBg");
  const color = useColorModeValue("grey.500", "grey.150");

  const defaultDescription = useMemo(() => {
    const map: Record<EmptyCrateProps["type"], string> = {
      transaction: "You are yet to complete a Transaction",
      wallet: "No wallet",
      earn: `You don't have a ${when(!!midfix, midfix, "")} subscription`,
      notification: `No Notifications`,
      p2p: "No listings",
      greenbox: "No Greenbox created yet",
      coinSelect: `Tokens with name "${midfix}" not found`,
    };

    return map[type];
  }, [type, midfix]);

  const Illustration = useMemo(() => {
    const map: Record<
      string,
      React.FunctionComponent<
        React.SVGProps<SVGSVGElement> & {
          title?: string | undefined;
        }
      >
    > = {
      transaction: EmptyTransactionIllustration,
      notification: EmptyNotificationIllustration,
      p2p: EmptyTransactionIllustration,
      greenbox: EmptyTransactionIllustration,
      default: EmptyTransactionIllustration,
      coinSelect: ErrorMojiSVG,
    };

    return map[type ?? "default"];
  }, [type]);

  return (
    <VStack mt="0" py="60px" {...xprops}>
      <Box as={Illustration} color={bg} />
      <Text fontSize="16px" fontWeight="600" color={color}>
        {description ?? defaultDescription}
      </Text>

      {children && children}
    </VStack>
  );
}
